import styled, { css } from 'styled-components/macro';
import { NavLink } from 'react-router-dom';

export const Nav = styled.nav`
  background: white;

  @media screen and (min-width: 50em) {
    background: none;
  }

  @media screen and (min-width: 50em) and (max-width: 62em) {
    font-size: 0.8em;
  }
`;

export const List = styled.ul`
  background: ${(p) => p.theme.SubNav};
  display: flex;
  overflow-x: auto;
  padding-left: ${({ theme }) => theme.spacing.xlarge};

  @media screen and (min-width: 800px) {
    padding-left: 0;
  }
  @media screen and (min-width: 900px) {
    padding-left: 0.5em;
  }
  @media screen and (min-width: 1000px) {
    padding-left: 0;
  }
  @media screen and (min-width: 1250px) {
    padding-left: 1em;
  }
  @media screen and (min-width: 1400px) {
    padding-left: 2em;
  }
  @media screen and (min-width: 1580px) {
    padding-left: 3em;
  }
  @media screen and (min-width: 1800px) {
    padding-left: 4em;
  }
  @media screen and (min-width: 2100px) {
    padding-left: 5.5em;
  }
  @media screen and (min-width: 2500px) {
    padding-left: 7.5em;
  }
  @media screen and (min-width: 2800px) {
    padding-left: 145px;
  }
`;

export const ListItem = styled.li<{ active?: boolean }>`
  color: ${({ active, theme }) => active && theme.AccentGreen};
  text-align: center;
`;

export const Link = styled(NavLink)`
  ${({ theme }) => css`
    transition: ${`${theme.transitionDuration} ${theme.timingFunction} background`};
    background: initial;
    color: white;
    padding: ${`${theme.spacing.medium} ${theme.spacing.medium}`};
    margin: ${`0 ${theme.spacing.small}`};
    font-size: 1em;
    font-weight: 600;
    border-bottom: 3px solid transparent;
    white-space: nowrap;

    &.active {
      color: ${theme.AccentGreen};
    }

    &:not(.active) {
      &:hover,
      &:focus {
        border-bottom: 3px solid ${theme.AccentGreen};
      }
      &:active {
        color: ${theme.AccentGreen};
      }
    }
  `}

  display: block;
  text-decoration: none;
`;
